(function () {
  'use strict';

  /* ── Sort select ─── */
  var sortSel = document.getElementById('ColSortSelect');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      var form = document.getElementById('ColFilterForm');
      var hid  = form.querySelector('input[name="sort_by"]');
      if (hid) hid.value = this.value;
      form.submit();
    });
  }

  /* ── Desktop filter dropdowns ─── */
  var dropBtns = document.querySelectorAll('.col-filter-drop__btn');

  function closeAll() {
    dropBtns.forEach(function (b) {
      b.classList.remove('is-open');
      b.setAttribute('aria-expanded', 'false');
      var panel = document.getElementById(b.getAttribute('aria-controls'));
      if (panel) panel.classList.remove('is-open');
    });
  }

  dropBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var panelId = btn.getAttribute('aria-controls');
      var panel   = document.getElementById(panelId);
      var wasOpen = btn.classList.contains('is-open');
      closeAll();
      if (!wasOpen && panel) {
        btn.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        panel.classList.add('is-open');
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.col-filter-drop')) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  /* ── Mobile drawer ─── */
  var drawer        = document.getElementById('ColDrawer');
  var drawerOverlay = document.getElementById('ColDrawerOverlay');
  var drawerClose   = document.getElementById('ColDrawerClose');
  var mobileBtn     = document.getElementById('ColMobileFilterBtn');

  function openDrawer()  { if (drawer) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); } }

  if (mobileBtn)     mobileBtn.addEventListener('click', openDrawer);
  if (drawerClose)   drawerClose.addEventListener('click', closeDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

  /* ── Mobile accordion groups ─── */
  document.querySelectorAll('.col-fgroup__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var body    = this.nextElementSibling;
      var isOpen  = body.classList.contains('is-open');
      body.classList.toggle('is-open', !isOpen);
      this.classList.toggle('is-open', !isOpen);
      this.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  /* ── Quick add to cart ─── */
  window.reaperQA = function (e, variantId, btn) {
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;

    btn.disabled    = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) {
        btn.textContent = data.description || 'Error';
        setTimeout(function () { btn.disabled = false; btn.textContent = 'Add to Bag →'; }, 2000);
        return;
      }
      btn.textContent  = '✓ Added!';
      btn.style.background = '#22c55e';
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      setTimeout(function () {
        btn.disabled         = false;
        btn.textContent      = 'Add to Bag →';
        btn.style.background = '';
      }, 2200);
    })
    .catch(function () {
      btn.disabled    = false;
      btn.textContent = 'Add to Bag →';
    });
  };

})();